import { apiFetch } from './client';

/**
 * An SFTP IP block bans a source IP from connecting to the SFTP gateway. Blocks
 * are usually created automatically after repeated auth failures (`failCount`),
 * but a platform-admin can also add one manually with an optional expiry.
 */
export interface SftpIpBlock {
  id: string;
  ipAddress: string;
  reason: string | null;
  failCount: number;
  blockedAt: string;
  expiresAt: string;
  isActive: boolean;
  createdAt: string;
}

export interface CreateSftpIpBlockPayload {
  ipAddress: string;
  reason?: string;
  durationMinutes?: number;
}

export const sftpIpBlocksApi = {
  list: (activeOnly?: boolean): Promise<SftpIpBlock[]> => {
    const qs = activeOnly ? '?active=true' : '';
    return apiFetch<SftpIpBlock[]>(`/sftp-ip-blocks${qs}`);
  },

  create: (data: CreateSftpIpBlockPayload): Promise<SftpIpBlock> => {
    return apiFetch<SftpIpBlock>('/sftp-ip-blocks', { method: 'POST', data });
  },

  remove: (id: string): Promise<SftpIpBlock> => {
    return apiFetch<SftpIpBlock>(`/sftp-ip-blocks/${id}`, { method: 'DELETE' });
  },
};
